import * as d3 from 'd3';
import { ItemFormat } from '../interfaces';
import { ElementRender } from './ElementeRenderer';
import { highlightOnHover } from './stroke-hover';

export class Circles extends ElementRender {
    private _listeners: { [event: string]: (d: ItemFormat, selection: d3.Selection<ItemFormat>) => void }
        = {};
    private _radius = 5;

    constructor(selection: d3.Selection<any>) {
        super(selection, 'symbols');
    }

    addListener(eventName: string, callback: (d: ItemFormat, selection: d3.Selection<ItemFormat>) => void) {
        this._listeners[eventName] = callback;
        return this;
    }

    removeListener(eventName: string) {
        delete (this._listeners[eventName]);
        return this;
    }

    radius(): number;
    radius(value: number): this;
    radius(value?: number): this | number {
        if (!arguments.length) {
            return this._radius;
        }
        this._radius = value;
        return this;
    }

    render(data: ItemFormat[]) {
        const ratio = this.ratio() || 1;
        const selection = this.container()
            .classed('hidden-group', !this.visible());
        const databound = selection
            .selectAll('circle')
            .data(data);
        databound.exit()
            .remove();
        highlightOnHover(databound
            .enter()
            .append('circle'), this._listeners);
        databound
            .transition()
            .attr({
                'cx': d => {
                    const cx = d.x + d.width / 2;
                    return isNaN(cx) ? 0 : cx;
                },
                'cy': d => {
                    const cy = d.y;
                    return isNaN(cy) ? 0 : cy;
                },
                'r': this._radius * ratio
            })
            .style('fill', d => d.item.classes.length ? null : d.color)
            .attr('class', d => d.item.classes.join(' '));
    }
}